export default "__VITE_ASSET__a2e472e5__"